import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";
import Status from "./Status";
import { displayCreatedAt } from "utils/helpers";
import ConditionalBoldText from "UI/ConditionalBoldText";

export const notificationsColumns = [
  {
    label: "Created At",
    field: "createdAt",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: (row) => (
      <ConditionalBoldText text={displayCreatedAt(row)} row={row} />
    ),
  },
  {
    label: "Practice",
    field: "practiceName",
    xs: 1.75,
    sm: 1.75,
    md: 1.75,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.practiceName} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Region",
    field: "practiceMarketingRegion",
    xs: 0.75,
    sm: 0.75,
    md: 0.75,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.practiceMarketingRegion} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Provider",
    field: "providers",
    xs: 1.75,
    sm: 1.75,
    md: 1.75,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.providers} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Sender",
    field: "originatorName",
    xs: 1.75,
    sm: 1.75,
    md: 1.75,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.originatorName} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "originatorPhone",
    xs: 1.25,
    sm: 1.25,
    md: 1.25,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.originatorPhone} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  // {
  //   label: "Patient",
  //   field: "patient",
  //   xs: 1.5,
  //   sm: 1.5,
  //   md: 1.5,
  //   renderer: ({ patient }) => (
  //     <TextFieldWithEllipsis>{patient}</TextFieldWithEllipsis>
  //   ),
  // },
  {
    label: "Recipients",
    field: "specialists",
    xs: 2.5,
    sm: 2.5,
    md: 2.5,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.specialists} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Status",
    field: "status",
    xs: 0.75,
    sm: 0.75,
    md: 0.75,
    renderer: ({ status }) => <Status value={status} />,
  },
];

export const notificationsMobileColumns = [
  {
    label: "Created At",
    field: "createdAt",
    xs: 4,
    sm: 4,
    md: 4,
    renderer: (row) => (
      <ConditionalBoldText text={displayCreatedAt(row)} row={row} />
    ),
  },
  {
    label: "Practice",
    field: "practiceName",
    xs: 3.5,
    sm: 3.5,
    md: 3.5,
    renderer: (row) => (
      <ConditionalBoldText
        text={
          <TextFieldWithEllipsis>{row?.practiceName}</TextFieldWithEllipsis>
        }
        row={row}
      />
    ),
  },
  {
    label: "Sender",
    field: "originatorName",
    xs: 2.5,
    sm: 2.5,
    md: 2.5,
    renderer: (row) => (
      <TextFieldWithEllipsis>
        <ConditionalBoldText text={row?.originatorName} row={row} />
      </TextFieldWithEllipsis>
    ),
  },
  {
    label: "Status",
    field: "status",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ status }) => <Status value={status} />,
  },
];
